<script setup>
const props = defineProps({
  assessment: {
    type: Object,
    required: true,
  },
})

const selectedTab = ref('general')

const tabs = [
  { label: 'Algemeen', value: 'general' },
  { label: 'VMBO', value: 'vmbo' },
  { label: 'MBO', value: 'mbo' },
  { label: 'HBO', value: 'hbo' },
  { label: 'WO', value: 'wo' },
]

const scores = computed(() => {
  const results = {}
  for (const data of props.assessment?.data) {
    const abstract = data?.subdata?.find(
      (subdata) => subdata.name === 'abstract',
    )
    const numeric = data?.subdata?.find((subdata) => subdata.name === 'numeric')
    const verbal = data?.subdata?.find((subdata) => subdata.name === 'verbal')

    if (data.name === 'IQ') {
      results.general = {
        general: data.assessmentScore.toFixed(2),
        abstract: abstract.assessmentScore.toFixed(2),
        numeric: numeric.assessmentScore.toFixed(2),
        verbal: verbal.assessmentScore.toFixed(2),
      }
    } else {
      results[data.name] = {
        general: data.assessmentScore.toFixed(2),
        abstract: getStringForStenScore(abstract.assessmentScore),
        numeric: getStringForStenScore(numeric.assessmentScore),
        verbal: getStringForStenScore(verbal.assessmentScore),
      }
    }
  }
  return results
})

function getStringForStenScore(score) {
  if (score > 6) return 'Bovengemiddeld'
  if (score < 5) return 'Benedengemiddeld'
  return 'Gemiddeld'
}
</script>

<template>
  <div class="flex flex-col gap-6">
    <div class="flex flex-wrap gap-1">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        class="rounded-xl border px-2 py-1 text-xxs font-bold uppercase transition-all"
        :class="{
          'border-secondary bg-secondary text-white': selectedTab === tab.value,
          ' border-gray-600 bg-gray-50 text-gray-800 ':
            selectedTab !== tab.value,
        }"
        @click="selectedTab = tab.value"
      >
        {{ tab.label }}
      </button>
    </div>

    <div class="flex flex-col gap-6">
      <div class="flex flex-col gap-1">
        <span class="text-sm font-semibold text-gray-800">Algemene score</span>
        <span class="text-sm text-gray-600">{{
          scores[selectedTab].general
        }}</span>
      </div>

      <div class="flex flex-col gap-1">
        <div class="flex items-center gap-1.5">
          <span class="text-sm font-semibold text-gray-800">Abstract </span>
          <InfoAbstract />
        </div>

        <span class="text-sm text-gray-600">{{
          scores[selectedTab].abstract
        }}</span>
      </div>

      <div class="flex flex-col gap-1">
        <div class="flex items-center gap-1.5">
          <span class="text-sm font-semibold text-gray-800">Numeriek </span>
          <InfoNumeric />
        </div>
        <span class="text-sm text-gray-600">{{
          scores[selectedTab].numeric
        }}</span>
      </div>

      <div class="flex flex-col gap-1">
        <div class="flex items-center gap-1.5">
          <span class="text-sm font-semibold text-gray-800">Verbaal </span>
          <InfoVerbal />
        </div>
        <span class="text-sm text-gray-600">{{
          scores[selectedTab].verbal
        }}</span>
      </div>
    </div>
  </div>
</template>
